import React, { useMemo } from 'react'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import { LyraDisplayLanguageTags } from '@lyrahealth-inc/shared-app-logic/src/features/intl/constants'
import { EnableTranslations } from '@lyrahealth-inc/shared-app-logic/src/features/intl/EnableTranslations'
import { useSmartlingContextCapture } from '@lyrahealth-inc/shared-app-logic/src/features/intl/hooks/useSmartlingContextCapture'
import { LyraIntl } from '@lyrahealth-inc/shared-app-logic/src/features/intl/LyraIntl'

import AppIntlProvider from './AppIntlProvider'
import { getLyraWebLanguageConfig } from './config'

export const LyraWebIntlProvider: React.FC = ({ children }) => {
  const flags = useFlags()
  const intl = useMemo(() => new LyraIntl<LyraDisplayLanguageTags>(getLyraWebLanguageConfig(flags)), [flags])

  return (
    <AppIntlProvider intl={intl as LyraIntl<string>}>
      <ContextCapture />
      {flags.isDisplayLanguageEnabled ? <EnableTranslations>{children}</EnableTranslations> : children}
    </AppIntlProvider>
  )
}

const ContextCapture: React.FC = () => {
  useSmartlingContextCapture('QWO4ncq74mg7R5feR-bQTQ')
  return null
}
